<template>
  <vx-card class="search-nav mb-4">
    <div v-if="layout === 'filter'">
      <div>
        <vs-button class="px-6 py-1" color="secondary" type="border" @click="onClickOpenFilter">
          <div class="flex pt-2 justify-center items-center">
            <feather-icon icon="FilterIcon" class="mr-2" style="width:20px; height: 20px;"/>
            <span>필터</span>
          </div>
        </vs-button>
      </div>

      <vs-popup :active.sync="openFilter" title="필터">
        <div ref="filter-search" class="filter-search">
          <slot :filter="true" :setRef="childRef"></slot>
          <div class="flex gap-2 justify-end pt-2">
            <vs-button color="secondary" type="border" @click="handleClose">닫기</vs-button>
            <vs-button color="secondary" type="border" @click="handleReset">초기화</vs-button>
            <vs-button color="secondary" @click="handleSearch">적용</vs-button>
          </div>
        </div>
      </vs-popup>

    </div>

    <vs-row v-else class="flex flex-col xl:flex-row gap-y-4" :class="align">
      <vs-col class="flex-1 flex xl:inline-flex flex-wrap gap-4" vs-align="center">
        <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
          <slot></slot>
        </div>
      </vs-col>
      <vs-col class="flex w-auto items-end gap-4" style="margin-left: auto; padding: 0.5rem 0">
        <vs-button v-if="useReset" color="secondary" type="border" @click="resetSearch">초기화</vs-button>
        <vs-button v-if="useSearchButton" color="secondary" @click="handleSearch">{{ $t("search.검색") }}</vs-button>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
export default {
  name: "SearchNav",
  props: {
    align: String,
    size: String,
    useReset: Boolean,
    useSearchButton: {
      type: Boolean,
      default: true,
    },
    layout: {
      type: String,
      default: "default", // default, filter
    }
  },
  data () {
    return {
      openFilter: false,
    }
  },
  methods: {
    childRef(refName, component) {
      if (!this.$refs[refName]) {
        this.$refs[refName] = [];
      }
      if (component) {
        // 자식 컴포넌트의 ref 를 부모 컴포넌트에서 사용하기 위해 설정
        // if (this.setRef) {
        //   this.setRef('searchFilterItem', this.$refs.searchFilterItem)
        // }
        this.$refs[refName].push(component);
      }
    },
    resetSearch() {
      this.$emit("resetSearch");
    },
    handleSearch() {
      this.$emit("handleSearch");
      this.openFilter = false;
    },
    handleReset() {
      if (this.$refs["searchFilterItem"]) {
        this.$refs["searchFilterItem"].forEach((item) => {
          if (item.remove) {
            item.remove();
          }
        });
      }
    },
    handleClose() {
      this.openFilter = false;
    },
    onClickOpenFilter() {
      this.openFilter = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.search-nav {
  border-radius: 0;

  @media (min-width: theme("screens.xl")) {
    border-radius: theme("borderRadius.lg");
  }
}

.filter-button {
  padding: 10px 24px;
  color: #7E72F2;
  border: 1px solid #7E72F2;
  border-radius: 4px;

}

</style>
<style lang="scss">
.search-nav .vx-card__collapsible-content .vx-card__body {
  padding: 1rem 1.5rem;
}

.filter-search {
  display: grid;
  gap: 10px;
}
</style>
